/**
 * Mock data for GuaranteePageView fields not yet available from API.
 * This will be merged with real API response at the collateralApi level.
 * Remove fields from here as they become available from the backend.
 */
export const guaranteePageViewMock = {
  // Configuração - Coluna 1
  assignorRisk: 1250000.00,
  assignorRiskPercentage: 12.5,
  mainDebtors: 'PROTEC PRODUTOS AGRICOLAS LTDA; AGROCERRADO PRODUTOS AGRICOLAS',
  issueDate: '2025-02-14',
  currency: 'BRL',

  // Configuração - Coluna 2
  creditor: 'SCFI',
  analystName: 'Amanda',
  validationAnalystName: 'Ingrid',
  pendency: '',
  observation: '',
  traderHandoverDate: '2025-12-15',
  followUpAreas: '03/02/2026; 18/03;',

  // Status
  statusTrader: 'N/A' as 'CONCLUIDO' | 'AGUARDANDO DOC - Área Informada' | 'TEM PENDÊNCIA' | 'N/A',
  collateralSaved: 'N/A' as 'Sim' | 'NÃO TEM' | 'Quitada' | 'Promessa' | 'Renegociado' | 'N/A',
  debtorNotification: 'n/a' as 'Agrolend' | 'n/a' | 'confirmar' | 'FEITA CEDENTE',
  courtRegistration: false,
  contractToRegister: 'CF DE RECEBÍVEIS',

  // Métricas e checagem - Pesos
  weightTitles: 2,
  weightXml: 0,
  weightNfPdf: 2,
  weightCanhoto: 4,
  weightDuplicata: 0,
  weightValidation: 0,
  weightTotal: 8,

  // Métricas - Resumo checagem
  checkDetail: 'Planilha Checagem',
  checkDateTime: '2025-12-20T14:30:00',
  links: '',
};

export type GuaranteePageViewMock = typeof guaranteePageViewMock;
